// Styles for LandingStoreButtons component
import styled from '@emotion/styled';

export const StoreButtonsContainer = styled.div`
  gap: 12px;
`;

export const StoreLink = styled.a`
  display: inline-block;
  cursor: pointer;
`;

export const StoreImage = styled.img`
  object-fit: contain;
  height: auto;
`;